import React from 'react';
import { Play, Radio } from 'lucide-react';
export function Streaming() {
  return <section className="pt-48 pb-32 px-6 max-w-7xl mx-auto" data-id="element-310">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-311">
        <div data-id="element-312">
          <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase mb-8" data-id="element-313">
            Live <span className="text-[#FF0000]" data-id="element-314">Streaming</span>
          </h2>
          <p className="text-xl text-gray-400 mb-8" data-id="element-315">
            Broadcast directly to your fans without platform censorship or
            revenue cuts.
          </p>
          <div className="space-y-6" data-id="element-316">
            <div className="flex gap-4" data-id="element-317">
              <div className="w-12 h-12 bg-[#FF0000]/10 rounded-lg flex items-center justify-center shrink-0" data-id="element-318">
                <Play className="text-[#FF0000]" size={24} data-id="element-319" />
              </div>
              <div data-id="element-320">
                <h4 className="font-bold uppercase" data-id="element-321">4K Ultra HD</h4>
                <p className="text-gray-500 text-sm" data-id="element-322">
                  Crystal clear quality for your performances.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-323">
              <div className="w-12 h-12 bg-[#FF0000]/10 rounded-lg flex items-center justify-center shrink-0" data-id="element-324">
                <Radio className="text-[#FF0000]" size={24} data-id="element-325" />
              </div>
              <div data-id="element-326">
                <h4 className="font-bold uppercase" data-id="element-327">Low Latency</h4>
                <p className="text-gray-500 text-sm" data-id="element-328">
                  Real-time interaction with your audience.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="aspect-video bg-[#1A1A1A] rounded-3xl border border-white/10 overflow-hidden relative group" data-id="element-329">
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-330">
            <div className="w-20 h-20 bg-[#FF0000] rounded-full flex items-center justify-center shadow-[0_0_50px_rgba(255,0,0,0.4)] group-hover:scale-110 transition-transform cursor-pointer" data-id="element-331">
              <Play className="text-white ml-1" size={32} data-id="element-332" />
            </div>
          </div>
          <div className="absolute top-6 left-6 flex items-center gap-2" data-id="element-333">
            <div className="w-2 h-2 bg-[#FF0000] rounded-full animate-pulse" data-id="element-334"></div>
            <span className="text-[10px] font-bold uppercase tracking-widest" data-id="element-335">
              Live Preview
            </span>
          </div>
        </div>
      </div>
    </section>;
}